app.controller('studentWorthKnowingIndexCtrl', [
    '$scope', function ($scope) {
    }
]);